module.exports = __webpack_public_path__ + "img/br.569c260a.png";